import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, LockKeyhole, MapPin, Package } from 'lucide-react';
import { money } from '../api';

const ProductPrice = ({ product }) => {
  if (!product.pricing_visible) return <span className="price-locked" data-testid={`locked-price-${product.id}`}>
    <LockKeyhole size={14} />Business pricing
  </span>;
  return <span className="product-price" data-testid={`price-${product.id}`}>
    {money(product.tiers[0].price * 100)}<small>/ {product.unit} · excl. GST</small>
  </span>;
};

export const ProductCard = ({ product }) => <article className="product-card" data-testid={`product-card-${product.id}`}>
  <Link to={`/product/${product.id}`} data-testid={`product-image-${product.id}`} className="product-image">
    {product.image_url ? <img src={product.image_url} alt={product.name} loading="lazy" /> : <Package size={52} />}
    <span className="product-category">{product.category.replaceAll('-', ' ')}</span>
    <span className="product-image-arrow"><ArrowUpRight size={18} /></span>
  </Link>
  <div className="product-body">
    <div className="product-sku" data-testid={`sku-${product.id}`}>{product.sku}<span>HSN {product.hsn}</span></div>
    <Link to={`/product/${product.id}`} data-testid={`product-title-${product.id}`} className="product-name">{product.name}</Link>
    <div className="supplier-line"><MapPin size={12} />{product.supplier_city}<span>·</span>{product.supplier_name}</div>
    <div className="product-facts">
      <span data-testid={`moq-${product.id}`}>MOQ <strong>{product.moq.toLocaleString()} {product.unit}</strong></span>
      <span>{product.packaging}</span>
    </div>
    <div className="product-bottom"><ProductPrice product={product} />
      <Link data-testid={`product-view-${product.id}`} to={`/product/${product.id}`} aria-label={`View ${product.name}`}><ArrowUpRight size={20} /></Link>
    </div>
  </div>
</article>;